import React, { useState, useEffect, useContext } from 'react'


import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'

import { useNavigate,useLocation } from 'react-router-dom'
import moment from 'moment'

import DynamicIcon from '../../components/dynamicicon'
import JisButton from '../../components/controls/jisButton'
import JisPrompt from '../../components/jisprompt'
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import JisInternalPay from '../../components/core/internal_pay';
import PdfViewer from '../../components/controls/pdfviewer';
import JisTabButton from '../../components/controls/jisTabButton';
import { AffidavitTemplate } from '../../components/external/AffidavitTemplate';
import Pagenated from '../../components/pagenated';

function AffidavitDocuments() {
    const location = useLocation();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
   // console.log(profile);
    const [openSuccess, setOpenSuccess] = useState(false)
  //  const {temptype} = useParams();
    const [deleteBox, setDeleteBox] = useState(false)
    const tempUrl= `${Constants.apiUrl}/setup/templates/affidavit`;
    const [templates, setTemplates]=useState([]);
    const [openTemp, setOpenTemp ] =useState(false);
    const [filterTemps, setFilterTemps]=useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [index, setIndex] =useState(-1);
    const [search, setSearch] = useState('');
    const [docs, setDocs] =useState([]);
    const [config, setConfig]=useState([]);
   // const [alert, setAlert] = useState({open:false, title:'', subtitle:'', code:-10, data:{}});
    const [isPay, setIsPay] =useState(false);
    const [selectedtempid, setSelectedTempId]=useState(0);
    const [scheduleWindow, setScheduleWindow] = useState(false)
    const [schedule, setSchedule]= useState({});
    const [confirmSelect, setConfirmSelect]=useState(false);
    const [confirmUpload, setConfirmUpload]=useState(false);
    const [activeSelect, setActiveSelect]= useState({});
    const [openOption, setOpenOption] =useState(false);
    const [isExhibits, setIsExhibits]=useState(false);
    const [option, setOption] = useState(''); //document or template
    const [countExhibits, setCountExhibits]= useState(1);
    const [affidavitAmt, setAffidavitAmt] = useState(1500);
    const [exhibitAmt, setExhibitAmt] = useState(200);
    const [amount, setAmount] =useState(0);
    const [divisionId, setDivisionId] = useState(0);
    const [err, setErr]= useState('');
    const navigate = useNavigate();
    const [isDetails, setIsDetails] = useState(false);
    const [activeUpline, setActiveUpline] = useState(null)
    const [previewUrl, setPreviewUrl] =useState('');
    const [tab, setTab]= useState('pending');
    const role=location.pathname =='/affidavits'?'user':'cfo'; //this asume second url /cfo-affidavits
    console.log(`${location.pathname} and the role ${role}`)


    const [pageIndex, setPageIndex]=useState(0);
        const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
        const [count, setCount] = useState(0);

 useEffect(() => {
        if(pageIndex>=0){
          onLoad();
        }
                 
    }, [pageIndex,tab]);

    const onChangeTab=(t)=>{
      setTab(t);
      setPageIndex(0);
    }
    const onCancel=()=>{
      setIsPay(false);
      setSelectedTempId(0);
    }
    const onOk=()=>{
      console.log ('we are here already....')
        if(alert.code==0){
        //  var lk=`/AffidavitDocuments/${alert.data.templateId}/edit/${alert.data.uplineId}`;
           // navigate(lk)
           var a={id: alert.data.docId,caseTitle: 'N/A',caseNumber:'N/A', type:'affidavit',caseFeeId: alert.data.caseFeeId   };
        navigate("/view-document-template", {state: {item:a}});
        }
       
        setAlert({open:false});
    }
    const onCompleted=()=>{
      console.log('alert value');
      console.log(alert);
      var lk=`/AffidavitDocuments/${alert.data.templateId}/edit/${alert.data.uplineId}`;
      console.log(lk);
        navigate(lk)
    }

      useEffect(() => {   
        console.log('profile details');
        console.log(profile);  
            LoadTemplates();
            
            onConfig();
             onLoad();
            
      }, [])

      const onUplineView=(up,index)=>{
         setIsDetails(true);
          var finalpath='';
         if(!up.isTemplate){
           finalpath= Constants.RelativeFiletoRelative(`${up.filename}`  );
         }else{
            finalpath=`${Constants.baseurl}/template-document/${up.id}`
         }
         
         console.log(finalpath);
         setPreviewUrl(finalpath )
         
      }

 useEffect(() => {    
  
  var amt=affidavitAmt;
      if(isExhibits){
          amt=amt + (exhibitAmt*countExhibits);

      }
      setAmount(amt);     
      }, [option,isExhibits,countExhibits])

 useEffect(() => {    
        if(config.length>0){
          const aff=config.find(d=>d.code=='affidavit-main');
          if(aff){
            setAffidavitAmt(aff.fee);
          }
          const affex=config.find(d=>d.code=='Affidavit-exhibit');
          if(affex){
            setExhibitAmt(affex.fee);
          }
        }
      }, [config])

      const onView=(itm)=>{
       // var a={id: itm.id, caseTitle: 'N/A',caseNumber:'N/A', type:'affidavit',caseFeeId: itm.caseFeeId,zoomLink: itm.zoomLink, schedule:itm.schedule   };
        navigate(`/affidavit-prepare/${itm.id}/${role}`);
        
    }   

    const onSelectSchedule=(doc)=>{
      setScheduleWindow(true);
      console.log(doc);
   
      setSchedule({...schedule, doc});
  }
  const onSaveSchedule=(doc)=>{
        
    console.log(schedule);
    var sch={docid:schedule.doc.id, zoomLink:schedule.zoom, scheduledBy:profile.username, scheduleDate : (schedule.date+' '+schedule.time)};

  
    const uploadurl=`${Constants.apiUrl}/filing/e-swearing/schedule/${schedule.doc.id}`
    const formData = new FormData();
      

        // Sending the FormData using fetch
        setIsLoading(true);
        fetch(uploadurl, {
        method: 'POST',
        body: JSON.stringify(sch),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        })
        .then(response => response.json())
        .then(data => {
            setIsLoading(false);
            if(data.code==0){
                //saved already
                //first upldate the row and show dialog box
                //setFilterTemps(filterTemps.map(i => i.id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, schedule:sch.scheduleDate} : i));

               setSchedule({});
             
               setAlert({open:true, title:'Schedule an Appointment', subtitle:'Meeting Schedule is successful'})
               setScheduleWindow(false)
               onLoad();

            }
        })
        .catch(error => {
            console.error('Error:', error);
            setIsLoading(false);
    });
}



    const LoadTemplates=()=>{
         setIsLoading(true);
         fetch(tempUrl, {
             method: 'GET',
             headers: {
               'Content-type': 'application/json',
               Authorization: `Bearer ${token}`,
             },
           })
             .then((resp) => resp.json())
             .then((data) => {
                 setIsLoading(false);
                 if(data.code==0){
                     setTemplates(data.templates);
                     
                 }
                 
             })
             .catch(error => {
                 console.error(error);
                 setIsLoading(false);
             })
     }

     const onSearch=(ee)=>{
        setSearch(ee);
        if(ee!=''){
        const _filterSearch = docs?.filter(item => {
              const searchValue = item.docUploadLines[0].documentTitle.toLowerCase().includes(ee.toLowerCase()) || item.refid?.toLowerCase().includes(ee.toLowerCase())
          
              return searchValue;
            })
        setFilterTemps(_filterSearch);
        }else{
            setFilterTemps(docs);
        }
      
      }

     const onDelete =()=>{
        setDeleteBox(false);
     }

     const onNewTemplate=()=>{
      setOpenOption(true);
     }

     const onCloseTemp=()=>{
        setOpenTemp(false);  
      }
    
      const onSelectTemplate=(selected)=>{
        setActiveSelect(selected);
       setSelectedTempId(selected.id);
       setConfirmSelect(true);
        onCloseTemp();
       // setIsPay(true);
      }

      const onConfirmSelect=()=>{
        setConfirmSelect(false);
         setIsPay(true);
       }

       const onSelectOthers=()=>{
        setConfirmSelect(false);
        setOpenTemp(true);
       }

      const onLoad= async()=>{
        //for account registration
      
        try {
            setIsLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/affidavits/${tab}/${pageIndex}/${pageSize}`, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
          
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
              var cdocs=[];
              data.docs.forEach(doc => {
                const r= `LSJ/HC/AFF/${doc.docUploadLines[0]?.id}/${retrieveDocYear(doc)}`;
                cdocs.push({...doc, refid:r });
              });
              console.log('after reconstruct')
              console.log(cdocs)
                setDocs(cdocs);
                setFilterTemps(cdocs);
             if(pageIndex==0){
                setCount(data.totalCount);
              } 

            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onConfig= async()=>{
        
        const urls=`${Constants.apiUrl}/setup/otherpayitems/affidavit`;
        console.log(`the calling url ${urls}`);

        try {
           
            const resp = await fetch(urls, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            const data = await resp.json();
           setConfig(data);
            
          } catch (error) {
            console.error(error);
          }   
  }

  const retrieveDocYear=(currectdoc)=>{
    return currectdoc?.uploadDate==null ? moment(new Date()).format("YYYY"): moment(currectdoc?.uploadDate).format("YYYY")
   }

  

   const onOptionProceed =()=>{
    if(divisionId==0){
      setErr('Please select the court division you want to process the Affidavit');
      return;
    }
    setErr('');

setOpenOption(false);
      
      if(option=='template'){
          setOpenTemp(true);
      }else if(option=='document'){
        setConfirmUpload(true);
      }
   }

   const onUploadOk=()=>{
    //proceed to payment
    console.log('on upload click');
    setConfirmUpload(false);
    setIsPay(true);
   }

   const onUploadCancel=()=>{
    setOpenOption(true);
    setConfirmUpload(false);
   }

const onPickTemplate=()=>{
  setOpenOption(true);
  setOption('template');
}
const onUploadTemplate =()=>{
  setOpenOption(true);
  setOption('document');
}

 const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}

  return (
    <div className='affidavit-table'>
       
        <div className="body">
        
  <div className="all-div">
                    

   {role=='user' && <div style={{display:'flex'}}>
  <div className='box-details' onClick={onPickTemplate}>
                      <div style={{margin:8}}>
                        <DynamicIcon iname='edit' size={24} />
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:20, fontWeight:'bold'}}>
                          Create Affidavit Using Template
                        </div>
                        <div>Fill an affidavit using the available affidavit templates</div>
                        
                      </div>
                      <div>

                      </div>
                    </div>
                    <div className='box-details-inverse' onClick={onUploadTemplate}>
                      <div style={{margin:8}}>
                        <DynamicIcon iname='upload' size={24} />
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:20, fontWeight:'bold'}}>Upload Affidafit Document</div>
                      <div>Use this if your affidavit was downloaded from an organization (e.g CAC, School)</div>
                      
                      </div>
                      <div>

                      </div>
                    </div>
  </div>} 
               
                    
                </div>
<div className='tab_body'>
<div className='tab_section'>
            <JisTabButton isActive={tab=='pending'}  
       title="Pending" 
       isRoleBased={false} onClick={()=> onChangeTab('pending')}/>
       <JisTabButton isActive={tab=='scheduled'}  title="Scheduled" 
       isRoleBased={false} onClick={()=> onChangeTab('scheduled')}/>
       <JisTabButton isActive={tab=='completed'}  title="Completed" 
       isRoleBased={false} onClick={()=> onChangeTab('completed')}/>
        </div>
        <div className='tab_view'>
<div className="aff-table">
                
                <div className="table-wrapper">
                   
                    
                    <div className='table'>
                        <div class="section-cases">
                          <span>Affidavit Documents</span><span className='total'>{count}</span>
                        </div>
                      <table  className="case-table">
                        <thead>
                            <tr>
                                <th>AFF ID</th>
                                <th>Affidavit Title</th>
                                <th>Date Created</th>
                                <th>Type</th>
                                <th>Zoom Link</th> 
                                <th>Schedule Date</th>
                                <th>View Document</th>
                              {role=='cfo' && tab!="completed" && <th>Schedule</th>}  
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filterTemps.map((doc, i) => { return (
                                    <tr key={i}>
                                        <td>{ `LSJ/HC/AFF/${doc.docUploadLines[0]?.id}/${retrieveDocYear(doc)}`}</td>
                                        <td>{doc.docUploadLines[0].documentTitle}</td>
                                        
                                        <td>{moment(doc.createDate).format('D MMM, YYYY') }</td>
                                        <td>{'AFFIDAVIT'} </td>
                                        <td className={doc.schedule==null? '' :'meet-link'}> {doc.schedule!=null && <a href={doc.zoomLink} target='_blank'> Zoom Link </a>}  </td>
                                        <td>{doc.schedule!=null ? moment(doc.schedule).format("dddd, MMMM Do YYYY, h:mm a")  : 'Time not set'}</td>
                                      <td className='view-affbtn'>
                                     {!doc.isCompleted && <JisButton variant='plain' onClick={()=> onView(doc)}>View</JisButton>} 
                                     {doc.isCompleted && 
                                     <div> 
                                      {doc?.docUploadLines?.map((up,index)=>{ return (<div className='selected' onClick={()=> onUplineView(up,index)}>
                                            {up.documentTitle}
                                          </div>)
                                          
                                      })}
                                      </div>}
                                        </td>   
                                    
                                      {role=='cfo' && !doc.isCompleted && <td> 
                                          <JisButton variant='plain' icon="schedule"  onClick={() => onSelectSchedule(doc) }>
                                            {doc.schedule==null?'Schedule':'Reschedule' } </JisButton></td>}  
                                      
                                    </tr>
                                )})
                            } 
                        </tbody>
                    </table>
                    </div>
                   {filterTemps?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
                </div>
            </div>
        </div>
      </div>
            
            <JisPrompt open={deleteBox} title="Delete" onOk={onDelete} onCancel={() => setDeleteBox(false)}>
                <p>Do you want to delete this Affidavit Template?</p>
            </JisPrompt>
           
            {openSuccess && <div className={ "success open" }>
                <div className="success-box">
                    <h2>Successful</h2>
                    <p> Template deleted successfully</p>
                    <button className='red' onClick={()=> setOpenSuccess(false)}>Continue</button>
                </div>
            </div>}

        </div>
        <BackLoader open={isLoading}  />
     {/* {alert.open && <JisAlert {...alert} onOk={onOk} />}  */}

   {openTemp && <JisDialogForm title="AFFIDAVIT TEMPLATES" onClose={()=>setOpenTemp(false)}>
       
          <AffidavitTemplate affidavit_templates={templates} onSelected={onSelectTemplate} />
</JisDialogForm>}
          

         
{openOption && <JisDialogForm title='AFFIDAVIT ' onClose={()=>setOpenOption(false)} >
  <div style={{flex:1}}>
                   {/*  <div className={`selected ${option=='document'?'active':''}`} onClick={onOptionPdf}>
                      <h3>Upload PDF</h3>
                    </div>
                   
                    <div className={`selected ${option=='template'?'active':''}`} onClick={onOptionTemplate}>
                      <h3>Use JIS Template</h3>
                    </div> */}

                    <div>
                      <h3>Do you have Supporting Document (Exhibit)? </h3>
                    <JisCheckbox label="Please check this box if you have Supporting Document (Exhibit)" value={isExhibits} onChange={(e)=>setIsExhibits(e)} />
                    {isExhibits && <div  className="input-group">
                      <label> How many Exhibits to upload</label>
                      <div className='input-wrapper'>
                          <DynamicIcon iname="save" />
                          <input  placeholder='exhibit' type="number" required={true} name="countExhibits" 
                          value={countExhibits} onChange={(e)=>setCountExhibits(e.target.value)}   />
                      </div>
                  </div>}
                    </div>
                <div className="select-group">
                <label> Division <span className="required">*</span> </label>
                <select name="divisionId" value={divisionId}  onChange={(e)=>setDivisionId(e.target.value)} >
                    <option value=''>Select Division</option>
                    {frequentData?.divisions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
               {err!='' && <div className='error'>{err}</div>} 
                </div>
                    <div style={{textAlign:'center'}}>
                     <span>Amount Payable</span> <span style={{fontSize:20, fontWeight:'bold'}}> N {Constants.formatCurrency(amount)}</span>
                    </div>
                    <div style={{textAlign:'center'}}>
                      <JisButton onClick={onOptionProceed}>Proceed </JisButton>
                    </div>
                    
                  </div>
                 
                   

  </JisDialogForm>}

                <JisInternalPay isPay={isPay} name={profile?.firstName} email={profile?.primaryEmail} phone={profile?.primaryContactNumber}
                 amount={amount} docref={`${selectedtempid}-0-${profile?.id}-${profile?.username}`}
                  note={`affidavit-${option}-${selectedtempid}-${isExhibits}-${countExhibits}-${divisionId}`}
                  onCancel={onCancel} token={token}>

                </JisInternalPay>
         
              <JisPrompt open={confirmSelect} title="Confirm Template Selection" onOk={onConfirmSelect} onCancel={onSelectOthers} >
              <p>Please confirm if you selected the correct template '{activeSelect.title}''. Click 'Yes' to continue to payment or 'No' to select a different template</p>
                    
              </JisPrompt>

            <JisPrompt open={confirmUpload} title="Confirm Affidavit Option" onOk={onUploadOk} onCancel={onUploadCancel}>
              <p>Please confirm you choose Document upload option for your affidavit {`${isExhibits?`with Exhibits. Number of exhibit  ${countExhibits} `:''}`}</p>
              </JisPrompt>

            {scheduleWindow && <JisDialogForm title="Appointment Details" onClose={()=>setScheduleWindow(false)}>
                    <div>
                      <div  className="input-group">
                          <label> Zoom Link</label>
                          <div className='input-wrapper'>
                              <DynamicIcon iname="monitor-play" />
                            <input type="text" placeholder='Zoom Link' value={schedule.zoom} onChange={(e)=>setSchedule({...schedule, zoom:e.target.value})} />
                          </div>
                      </div>

                      <div  className="input-group">
                          <label> Zoom meeting date</label>
                          <div className='input-wrapper'>
                              <DynamicIcon iname="calendar-clock" />
                             <input type="date" placeholder='Zoom meeting date' value={schedule.date} onChange={(e)=>setSchedule({...schedule, date:e.target.value})} />
                          </div>
                      </div>

                    <div  className="input-group">
                          <label> Zoom meeting time</label>
                          <div className='input-wrapper'>
                              <DynamicIcon iname="monitor-play" />
                            <input type="time" placeholder='Zoom meeting time' value={schedule.time} onChange={(e)=>setSchedule({...schedule, time:e.target.value})} />
                          </div>
                      </div>   

                      <div>
                       <div className='groupbtn'>
                        <JisButton icon="calendar-clock" onClick={onSaveSchedule }>Schedule Appointment</JisButton>
                    <JisButton icon="x" variant={'outline'} onClick={() => setScheduleWindow(false)}>Cancel</JisButton>
                        </div>  
                    
                        </div>                  
                    </div>
              </JisDialogForm>} 
              {isDetails && <JisDialogForm title="Document Preview" onClose={() =>setIsDetails(false)}>
                <div>
                  <div style={{height:'90vh'}}>
                    <PdfViewer   pdfUrl={previewUrl}/>
                   
                    </div>
                </div>
      </JisDialogForm>}
            
    </div>
  )
}

export default AffidavitDocuments